import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/auth";

export default function PaymentSuccess() {
  const { refreshUser } = useAuth();

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-white p-6"
      data-testid="payment-success-page"
    >
      <div className="max-w-md w-full text-center flex flex-col items-center gap-5 border-2 border-gray-900 rounded-2xl p-10">
        <div className="w-16 h-16 rounded-full bg-[#673A80] text-white flex items-center justify-center">
          <Sparkles className="w-7 h-7" />
        </div>
        <h1
          className="text-3xl font-semibold tracking-tight"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          You&apos;re in. Lifetime unlocked.
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed">
          Thank you for supporting KEYVISION. Every scale, chord, and Circle-of-Fifths
          progression is now yours forever — and your PDF exports are watermark-free.
        </p>
        <Link to="/app">
          <Button
            data-testid="back-to-app-button"
            className="rounded-xl bg-gray-900 hover:bg-gray-700 text-white h-12 px-6 font-medium mt-2"
          >
            Back to the visualizer
          </Button>
        </Link>
      </div>
    </div>
  );
}
